import React, { FC } from 'react';

import { Box } from '@mantine/core';

const TextReplacer: FC<{
    replaces: Record<string, React.ReactNode>;
    children: string;
}> & {
    Underline: FC<{ color?: string; children: React.ReactNode }>;
    Gradient: FC<{ children: React.ReactNode }>;
} = ({ replaces, children }) => {
    const keys = Object.keys(replaces);
    const escapedKeys = keys.map((key) => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const regex = new RegExp(`(${escapedKeys.join('|')})`, 'g');
    const parts = children.split(regex);

    return (
        <>
            {parts.map((part) => {
                return replaces[part] || part;
            })}
        </>
    );
};

TextReplacer.Underline = ({ color = 'var(--mantine-color-gray-4)', children }) => (
    <Box
        style={{
            display: 'inline',
            textDecoration: 'underline',
            textDecorationColor: color,
            textUnderlineOffset: '4px',
        }}
    >
        {children}
    </Box>
);

TextReplacer.Gradient = ({ children }) => (
    <Box component="span" className="gradient-cyan-green" fw={600}>
        {children}
    </Box>
);

export { TextReplacer };
